var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h3", { staticClass: "heading" }, [_vm._v("Additional Information")]),
      _vm._v(" "),
      _vm._l(_vm.additionalInformationProp, function(info, i) {
        return _c("div", { key: i }, [
          _c("div", {
            staticClass: "prose",
            domProps: { innerHTML: _vm._s(info.content) }
          })
        ])
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }